import { render, staticRenderFns } from "./Question5.vue?vue&type=template&id=7136d07b&scoped=true&"
import script from "./Question5.vue?vue&type=script&lang=js&"
export * from "./Question5.vue?vue&type=script&lang=js&"
import style0 from "./Question5.vue?vue&type=style&index=0&id=7136d07b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7136d07b",
  null
  
)

export default component.exports